import { render, staticRenderFns } from "./community-convention.vue?vue&type=template&id=18b80556&scoped=true"
import script from "./community-convention.vue?vue&type=script&lang=js"
export * from "./community-convention.vue?vue&type=script&lang=js"
import style0 from "./community-convention.vue?vue&type=style&index=0&id=18b80556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b80556",
  null
  
)

export default component.exports